import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=6a5e30c1&scoped=true"
import script from "./strategy.vue?vue&type=script&lang=js"
export * from "./strategy.vue?vue&type=script&lang=js"
import style0 from "./strategy.vue?vue&type=style&index=0&id=6a5e30c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5e30c1",
  null
  
)

export default component.exports